export default "__VITE_ASSET__71bd8274__"